import { apiClient } from 'client/core/network/apiClient';
import { PaginatedResult } from 'common/dto/shared/PaginatedResult';
import { ICreateRequestDto, IRequestsQueryDto } from 'common/dto/RequestDto';
import { IRequest } from 'common/schema/request/Request';
import { IRequestStateDto } from 'common/dto/RequestStateDto';
import { IRequestPreviewGenerationResponse } from 'common/dto/RequestPreviewDto';
import { ICommissionRankDto } from 'common/dto/CommissionRankDto';
import { ICommissionRank } from 'server/schema/procedure/request-ranking/CommissionRank';

export const RequestApi = {
  front: {
    listOwned: (opts: { query: IRequestsQueryDto }) =>
      apiClient.get<PaginatedResult<IRequest>>(`/requests/projection/owned`, {
        params: opts.query
      })
  },

  backOffice: {
    getFromProcedure: (opts: {
      procedureId: number;
      query: IRequestsQueryDto;
    }) =>
      apiClient.get<PaginatedResult<IRequest>>(
        `/procedures/${opts.procedureId}/requests`,
        { params: opts.query }
      ),
    rank: (opts: {
      procedureId: number;
      requestId: number;
      points: ICommissionRankDto;
    }) =>
      apiClient.post(
        `/procedures/${opts.procedureId}/requests/${opts.requestId}/ranking`,
        opts.points
      ),

    listRanks: (opts: { procedureId: number; requestId: number }) =>
      apiClient.get<PaginatedResult<ICommissionRank>>(
        `/procedures/${opts.procedureId}/requests/${opts.requestId}/ranking`
      ),

    checkClosed: () => apiClient.post(`/requests/actions/check-closed`)
  },

  find: (opts: { id: number }) =>
    apiClient.get<IRequest>(`/requests/${opts.id}`),

  create: (opts: { procedureId: number; input: ICreateRequestDto }) =>
    apiClient.post<IRequest>(
      `/procedures/${opts.procedureId}/requests`,
      opts.input
    ),

  update: (opts: { id: number; input: ICreateRequestDto }) =>
    apiClient.put<IRequest>(`/requests/${opts.id}`, opts.input),

  send: (opts: { id: number }) =>
    apiClient.post<IRequest>(`/requests/${opts.id}/actions/send`),

  getState: (opts: { procedureId: number }) =>
    apiClient.get<IRequestStateDto>(
      `/procedures/${opts.procedureId}/requests/state`
    ),

  preview: {
    generate: (opts: {
      procedureId: number;
      input: ICreateRequestDto;
      documentId: number;
    }) =>
      apiClient.post<IRequestPreviewGenerationResponse>(
        `/procedures/${opts.procedureId}/requests/preview/${opts.documentId}`,
        opts.input
      )
  },

  links: {
    /** Link alla pagina di dettaglio di un documento di una richiesta inviata */
    documentDetail: (
      isAdmin: boolean | undefined,
      id: number | null,
      token: string
    ) => {
      return isAdmin
        ? `${id}/documents/${token}`
        : `/richieste/${id}/dettaglio/documento/${token}`;
    },

    documentBacklink: (
      isAdmin: boolean | undefined,
      requestId: number,
      procedureId: number,
      isTypeEach: boolean
    ) => {
      return isAdmin
        ? `/admin/procedures/${procedureId}/requests/${
            isTypeEach ? requestId : ''
          }`
        : `/richieste/${requestId}/dettaglio/${isTypeEach ? 'fascicolo' : ''}`;
    }
  }

  // Allegati
  // uploadAttachment: (opts: { data: FormData }) =>
  //   apiClient.post<any>(`/procedure-attachments`, opts.data, {
  //     headers: { 'Content-Type': 'multipart/form-data' }
  //   })
};
